import { languages } from 'monaco-editor/esm/vs/editor/editor.api';
import {setupMode} from './mode'


const knownLanguages = {
  groovy() {
    return import('@/commons/components/monaco-editor/basic-languages/groovy/groovy.contribution.js')
  },
  xml() {
    return import('@/commons/components/monaco-editor/basic-languages/xml/xml.contribution.js')
  }
}

const dynamicLangs = {}, iqpDslBasicLangModules = {};
export default function dynamicLanguage(baseLangId, params) {
  const noneParams = params === null || params === void 0;
  const strParams = noneParams ? 'null' : JSON.stringify(params);
  const langs = dynamicLangs[baseLangId] || (dynamicLangs[baseLangId] = {});
  let iqpDslBasicLangModule = iqpDslBasicLangModules[baseLangId];
  let lang = langs[strParams];
  if(!lang) {
    if(!iqpDslBasicLangModule && baseLangId.startsWith('iqp')) {
      iqpDslBasicLangModule = iqpDslBasicLangModules[baseLangId] = 'iqp-dsl-language';
    }

    lang = langs[strParams] = Object.freeze({
      id: noneParams ? baseLangId : (baseLangId + '/' + strParams),
      baseId: baseLangId,
      num: Object.keys(langs).length,
      params: Object.freeze(params)
    });

    const alias = noneParams ? baseLangId : (baseLangId + '_' + lang.num);
    if(knownLanguages[baseLangId]) {
      knownLanguages[baseLangId]();
    } else {
      languages.register({
        id: lang.id,
        extensions: ['.' + alias],
        aliases: [alias],
        mimetypes: ['text/x-' + alias + '-source', 'text/x-' + alias]
      });
      if(iqpDslBasicLangModule) {
        languages.onLanguage(lang.id, function () {
          return setupMode({languageId:lang.id, params});
        });
      }
    }
  }
  return lang;
}
